import React from "react";
import { Helmet } from "react-helmet";
import {
  getThemePropertyValue,
  isInHiddenList,
  getThemeName
} from "utils/pluginHelpers";
import {
  GtmPageProvider,
  Button
} from "@company-mrv/mrv-design-system/components";
import { trackTrace } from "services/trackInsights";
import { useLocation, useHistory } from "react-router-dom";
import { MENU_REDIRECT_LINKS, ROUTES } from "utils/constants";
import { isMobileOrTablet } from "utils/functions";

import * as Styled from "./styles";

function VAErrorPage({ handleClick, handleIniciarVistoria }) {
  return (
    <GtmPageProvider page="Página de erro">
      <Styled.Container data-testid="erro-content">
        <Helmet>
          <title>Não foi possível exibir essa página.</title>
        </Helmet>

        <Styled.Illustration />

        <Styled.Content className="gtm-class-cat-erro">
          <Styled.Title>Não foi possível exibir essa página</Styled.Title>
          <Styled.Description>
            Estamos com uma instabilidade e já atuando para solucioná-la.
          </Styled.Description>
        </Styled.Content>

        {!isInHiddenList("ErrorIlustration") && (
          <Styled.Button onClick={handleClick}>Falar com a MIA</Styled.Button>
        )}

        <Styled.VistoriaSection>
          <Styled.VistoriaText>Tem uma vistoria agendada?</Styled.VistoriaText>
          <Button
            theme={getThemeName()}
            variant="ghost"
            liquid
            onClick={handleIniciarVistoria}
          >
            Iniciar vistoria
          </Button>
        </Styled.VistoriaSection>
      </Styled.Container>
    </GtmPageProvider>
  );
}

function DesktopErrorPage({ handleClick }) {
  return (
    <GtmPageProvider page="Página de erro">
      <Styled.Container data-testid="erro-content">
        <Helmet>
          <title>Não foi possível exibir essa página.</title>
        </Helmet>

        <Styled.Illustration />

        <Styled.Content className="gtm-class-cat-erro">
          <Styled.StatusCode>
            Não foi possível exibir essa página
          </Styled.StatusCode>
          <Styled.Title>
            Estamos com uma instabilidade e já
            <br /> atuando para solucioná-la.
          </Styled.Title>
          <Styled.Subtitle>Tente novamente mais tarde.</Styled.Subtitle>

          <Styled.Description>
            {getThemePropertyValue(
              "errorPage.description.textInfo",
              "Enquanto isso, você pode acessar o nosso WhatsApp e solicitar o que deseja para a MIA, nossa assistente virtual.\n\n"
            )}
          </Styled.Description>
        </Styled.Content>
        {!isInHiddenList("ErrorIlustration") && (
          <Styled.Button onClick={handleClick}>Iniciar conversa</Styled.Button>
        )}
      </Styled.Container>
    </GtmPageProvider>
  );
}

function ErrorPage(origin) {
  const location = useLocation();
  const history = useHistory();
  let isBoundary = false;
  if (origin.boundary) {
    isBoundary = true;
  }

  function handleClick() {
    trackTrace("Clique no botão MIA", "Redirecionamento feito com sucesso");
    window.open(MENU_REDIRECT_LINKS.MARIA_ROSA, "_blank");
  }

  function handleIniciarVistoria() {
    history.push(ROUTES.VISTORIA_ANTECIPADA_ENTRADA_ID, {
      fromVistoriaAccess: true
    });
  }

  if (location.state) {
    trackTrace("Tela de FAQ", `Função: ${location.state.detail}`);
  } else if (
    history.location.pathname !== "/relacionamento/erro/homolog" &&
    isBoundary === false
  ) {
    trackTrace("Tela de FAQ", "Acesso direto pela URL");
    history.push({ pathname: ROUTES.TRACK_WORK });
  }

  if (isMobileOrTablet()) {
    return (
      <VAErrorPage
        handleClick={handleClick}
        handleIniciarVistoria={handleIniciarVistoria}
      />
    );
  }

  return <DesktopErrorPage handleClick={handleClick} />;
}

export default ErrorPage;
